import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import { ModelApi } from '@/api/ai/model/model';
import { ApiKeyApi } from '@/api/ai/model/apiKey';
import { CommonStatusEnum } from '@/utils/constants';
import { DICT_TYPE, getIntDictOptions, getStrDictOptions } from '@/utils/dict';
import { AiModelTypeEnum } from '@/views/aip/utils/constants';
import { reactive, ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
/** API 模型的表单 */
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'ModelForm'
  },
  __name: 'ModelForm',
  emits: ['success'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    // const { t } = useI18n() // 国际化
    const message = useMessage(); // 消息弹窗
    const dialogVisible = ref(false); // 弹窗的是否展示
    const dialogTitle = ref(''); // 弹窗的标题
    const formLoading = ref(false); // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
    const formType = ref(''); // 表单的类型：create - 新增；update - 修改
    const formData = ref({
      id: undefined,
      keyId: undefined,
      name: undefined,
      model: undefined,
      platform: undefined,
      type: undefined,
      sort: undefined,
      status: CommonStatusEnum.ENABLE,
      temperature: undefined,
      maxTokens: undefined,
      maxContexts: undefined
    });
    const formRules = reactive({
      keyId: [{
        required: true,
        message: 'API 秘钥不能为空',
        trigger: 'blur'
      }],
      name: [{
        required: true,
        message: '模型名字不能为空',
        trigger: 'blur'
      }],
      model: [{
        required: true,
        message: '模型标识不能为空',
        trigger: 'blur'
      }],
      platform: [{
        required: true,
        message: '所属平台不能为空',
        trigger: 'blur'
      }],
      type: [{
        required: true,
        message: '模型类型不能为空',
        trigger: 'blur'
      }],
      sort: [{
        required: true,
        message: '排序不能为空',
        trigger: 'blur'
      }],
      status: [{
        required: true,
        message: '状态不能为空',
        trigger: 'blur'
      }],
      temperature: [{
        required: true,
        message: '温度参数不能为空',
        trigger: 'blur'
      }],
      maxTokens: [{
        required: true,
        message: '回复数 Token 数不能为空',
        trigger: 'blur'
      }],
      maxContexts: [{
        required: true,
        message: '上下文数量不能为空',
        trigger: 'blur'
      }]
    });
    const formRef = ref(); // 表单 Ref
    const apiKeyList = ref([]); // API 密钥列表
    /** 打开弹窗 */
    const open = async (type, id) => {
      dialogVisible.value = true;
      // dialogTitle.value = t('action.' + type)
      dialogTitle.value = '操作';
      formType.value = type;
      resetForm();
      // 修改时，设置数据
      if (id) {
        formLoading.value = true;
        try {
          formData.value = await ModelApi.getModel(id);
        } finally {
          formLoading.value = false;
        }
      }
      // 获得下拉数据
      apiKeyList.value = await ApiKeyApi.getApiKeySimpleList();
    };
    __expose({
      open
    }); // 提供 open 方法，用于打开弹窗
    /** 提交表单 */
    const emit = __emit; // 定义 success 事件，用于操作成功后的回调
    const submitForm = async () => {
      // 校验表单
      await formRef.value.validate();
      // 提交请求
      formLoading.value = true;
      try {
        const data = formData.value;
        if (data.type !== AiModelTypeEnum.CHAT) {
          delete data.temperature;
          delete data.maxTokens;
          delete data.maxContexts;
        }
        if (formType.value === 'create') {
          await ModelApi.createModel(data);
          // message.success(t('common.createSuccess'))
          message.success('创建成功');
        } else {
          await ModelApi.updateModel(data);
          // message.success(t('common.updateSuccess'))
          message.success('修改成功');
        }
        dialogVisible.value = false;
        // 发送操作成功的事件
        emit('success');
      } finally {
        formLoading.value = false;
      }
    };
    /** 重置表单 */
    const resetForm = () => {
      formData.value = {
        id: undefined,
        keyId: undefined,
        name: undefined,
        model: undefined,
        platform: undefined,
        type: undefined,
        sort: undefined,
        status: CommonStatusEnum.ENABLE,
        temperature: undefined,
        maxTokens: undefined,
        maxContexts: undefined
      };
      formRef.value?.resetFields();
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_Dialog = _resolveComponent("Dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_Dialog, {
        title: dialogTitle.value,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => dialogVisible.value = $event)
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: submitForm,
          type: "primary",
          disabled: formLoading.value
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("确 定")])),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("取 消")])),
          _: 1
        })]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formData.value,
          rules: formRules,
          "label-width": "130px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "所属平台",
            prop: "platform"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.value.platform,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.platform = $event),
              placeholder: "请输入平台",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getStrDictOptions)(_unref(DICT_TYPE).AI_PLATFORM), dict => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: dict.value,
                  label: dict.label,
                  value: dict.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "模型类型",
            prop: "type"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.value.type,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.type = $event),
              placeholder: "请输入模型类型",
              clearable: "",
              disabled: formData.value.id
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getIntDictOptions)(_unref(DICT_TYPE).AI_MODEL_TYPE), dict => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: dict.value,
                  label: dict.label,
                  value: dict.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "API 秘钥",
            prop: "keyId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.value.keyId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.keyId = $event),
              placeholder: "请选择 API 秘钥",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(apiKeyList.value, apiKey => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: apiKey.id,
                  label: apiKey.name,
                  value: apiKey.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "模型名字",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.name = $event),
              placeholder: "请输入模型名字"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "模型标识",
            prop: "model"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.model,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.value.model = $event),
              placeholder: "请输入模型标识"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "模型排序",
            prop: "sort"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: formData.value.sort,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.value.sort = $event),
              placeholder: "请输入模型排序",
              class: "!w-1/1"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "开启状态",
            prop: "status"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: formData.value.status,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formData.value.status = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getIntDictOptions)(_unref(DICT_TYPE).COMMON_STATUS), dict => {
                return _openBlock(), _createBlock(_component_el_radio, {
                  key: dict.value,
                  value: dict.value
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(dict.label), 1)]),
                  _: 2
                }, 1032, ["value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), formData.value.type === _unref(AiModelTypeEnum).CHAT ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "温度参数",
            prop: "temperature"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: formData.value.temperature,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formData.value.temperature = $event),
              placeholder: "请输入温度参数",
              min: 0,
              max: 2,
              precision: 2,
              class: "!w-1/1"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), formData.value.type === _unref(AiModelTypeEnum).CHAT ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "回复数 Token 数",
            prop: "maxTokens"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: formData.value.maxTokens,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formData.value.maxTokens = $event),
              placeholder: "请输入回复数 Token 数",
              min: 0,
              max: 8192,
              class: "!w-1/1"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), formData.value.type === _unref(AiModelTypeEnum).CHAT ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: "上下文数量",
            prop: "maxContexts"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: formData.value.maxContexts,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => formData.value.maxContexts = $event),
              placeholder: "请输入上下文数量",
              min: 0,
              max: 20,
              class: "!w-1/1"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model", "rules"])), [[_directive_loading, formLoading.value]])]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }
});